import { render, staticRenderFns } from "./FrontOfNationalSvg.vue?vue&type=template&id=24e85ca6&"
import script from "./FrontOfNationalSvg.vue?vue&type=script&lang=ts&"
export * from "./FrontOfNationalSvg.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports